export default {
  MULTIPLE_CHOICE: {
    DEFAULT_OPTIONS: ['ja', 'nei'],
    OFFLINE_MESSAGE:
      'Beklager, jeg har ingen internettforbindelse for øyeblikket. Derfor kan jeg ikke behandle svaret ditt.'
  }
}
